// extracted by mini-css-extract-plugin
export var cta = "cta-module--cta--vYb5X";
export var cta__content = "cta-module--cta__content--2z4fL";
export var cta__title = "cta-module--cta__title--kNRQ9";
export var cta__desc = "cta-module--cta__desc--np4K9";
export var cta__button = "cta-module--cta__button--gNQMm";
export var cta__media = "cta-module--cta__media--u+l8a";
export var cta__mediaImage = "cta-module--cta__mediaImage--0q39n";
export var cta__mediaWrapper = "cta-module--cta__mediaWrapper--UGZVN";
export var cta__background = "cta-module--cta__background--d4Doa";